const SERVICES = [
  {
    no: "01",
    key: "real_estate",
    title: "Real Estate Aerials",
    blurb:
      "Listings deserve a perspective only altitude can give. Lakefront homes, docks, and acreage photographed to sell faster.",
    bullets: ["Stills & 4K video", "Twilight / golden hour", "MLS-ready delivery"],
    image:
      "https://customer-assets.emergentagent.com/job_aerial-photo-book/artifacts/hvc031af_IMG_2513.jpeg",
  },
  {
    no: "02",
    key: "watersports",
    title: "Boats & Watersports",
    blurb:
      "Wakeboards, jet skis, pontoon parties — captured from above with smooth tracking shots that put viewers on the water.",
    bullets: ["Follow & orbit shots", "Multi-boat coordination", "Same-day edits"],
    image:
      "https://customer-assets.emergentagent.com/job_aerial-photo-book/artifacts/2nty5f2f_IMG_2504.jpeg",
  },
  {
    no: "03",
    key: "cinematic",
    title: "Cinematic Videos",
    blurb:
      "Short, scored films of the lake — proposals, anniversaries, brand stories. Built around mood, light, and quiet motion.",
    bullets: ["Color graded", "Licensed music", "Any length you want"],
    image:
      "https://customer-assets.emergentagent.com/job_aerial-photo-book/artifacts/rih5d3s3_IMG_2512.jpeg",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-40 border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="md:col-span-4">
            <span className="overline">§ 02 — Capabilities</span>
          </div>
          <div className="md:col-span-8">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white text-balance">
              Three lenses on the
              <br />
              <span className="text-[#E5A93B]">same body of water.</span>
            </h2>
          </div>
        </div>

        <div className="space-y-20 md:space-y-32">
          {SERVICES.map((s, i) => (
            <div
              key={s.key}
              data-testid={`service-${s.key}`}
              className={`grid md:grid-cols-12 gap-8 md:gap-12 items-center ${
                i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""
              }`}
            >
              <div className="md:col-span-7 relative group">
                <div className="aspect-[4/3] overflow-hidden bg-[#0D1322]">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                  />
                </div>
                <div className="absolute top-4 left-4 font-mono text-xs tracking-[0.3em] text-white/80 bg-black/40 backdrop-blur px-3 py-1.5 border border-white/10">
                  / {s.key.toUpperCase()}
                </div>
              </div>
              <div className="md:col-span-5">
                <div className="font-mono text-7xl md:text-8xl font-black text-[#E5A93B]/20 leading-none mb-4">
                  {s.no}
                </div>
                <h3 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-5">
                  {s.title}
                </h3>
                <p className="text-white/70 text-base md:text-lg leading-relaxed mb-7 font-light">
                  {s.blurb}
                </p>
                <ul className="space-y-3 mb-8 border-t border-white/10 pt-6">
                  {s.bullets.map((b) => (
                    <li
                      key={b}
                      className="flex items-center gap-3 text-sm text-white/80"
                    >
                      <span className="h-1.5 w-1.5 bg-[#E5A93B]" />
                      <span className="font-mono tracking-wider uppercase text-xs">
                        {b}
                      </span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#book"
                  data-testid={`service-${s.key}-cta`}
                  className="inline-flex items-center gap-2 text-[#E5A93B] hover:text-[#FACC15] text-xs font-bold uppercase tracking-[0.2em] border-b border-[#E5A93B]/40 hover:border-[#FACC15] pb-1 transition-colors"
                >
                  Inquire about {s.title}
                  <span>→</span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
